import { Seo } from "@/components/layout/Seo";
import { Reveal, Overline } from "@/components/Reveal";
import { ServicesGrid } from "@/components/sections/ServicesGrid";
import { FinalCta } from "@/components/sections/CallToActions";
import { useLang } from "@/context/LanguageContext";

export default function ServicesPage() {
  const { t } = useLang();
  return (
    <>
      <Seo page="services" />
      <section className="pt-14 md:pt-20 pb-2">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="max-w-3xl">
            <Overline>{t.servicesPage.overline}</Overline>
            <h1 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-navy mt-4">
              {t.servicesPage.title}
            </h1>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-navy/70">{t.servicesPage.intro}</p>
          </Reveal>
        </div>
      </section>
      <ServicesGrid showHeader={false} />
      <FinalCta />
    </>
  );
}
